import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import "../Styles/CoursesPage.css";

 /*
const coursesData = [
    {
        id: 1,
        title: "MAMOGRAFİ",
        instructor: "Dr. John Doe",
        description: "Learn advanced mammography techniques.",
        image: "/images/mamografi_drawing.jpg",
        students: 25,
        date: "12 / 7 / 2018",
        duration: "01h 30m",
        rating: 4.5,
        reviews: 250,
        price: "Ücretsiz",
    },
    {
        id: 2,
        title: "Radiology Basics",
        instructor: "Dr. Jane Smith",
        description: "An introduction to radiology for beginners.",
        image: "/images/mamografi_drawing.jpg",
        students: 30,
        date: "10 / 5 / 2019",
        duration: "02h 00m",
        rating: 4.8,
        reviews: 180,
        price: "Ücretsiz",
    },
];
*/
function CoursesPage() {

    const [courses, setCourse] = useState(null);
    useEffect(() => {
        fetchCourses();
    }, []);

    const fetchCourses = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/courses`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch data. Status: ${response.status}`);
            }

            const data = await response.json();
            console.log(data);
            setCourse(data);

        } catch (error) {
            console.error("Error fetching question groups:", error.message);
        }
    };
    return (
        <div className="course-container">
            <h2>Available Courses</h2>
            <div className="course-grid">
                {courses?.map((course) => (
                    <div key={course.id} className="course-card">

                        <img src="/images/mamografi_drawing.jpg" alt={course.name}/>

                        <div className="course-details">
                            <small><i className="fa fa-calendar"></i> Başlangıç Tarihi:{course.startDate}</small>
                            <small><i className="far fa-clock text-primary"></i> Bitiş Tarihi: {course.endDate}
                            </small>
                        </div>

                        <h3>{course.name}</h3>
                        {/*
                        <div className="course-footer">
                                            <span><i
                                                className="fa fa-star text-primary"></i> rating </span>
                            <span>price</span>
                        </div>
*/}
                        <div className="course-buttons">
                            <Link to={`/course-details/${course.id}`}
                                  className="course-button">Detaylar</Link>

                        </div>


                    </div>
                ))}
            </div>
        </div>
    );
}

export default CoursesPage;
